import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Process } from '@zerops/models/process';
import { FirstClassPrometheusSuccessResponse } from './first-class-recipe-base.model';

@Injectable({ providedIn: 'root' })
export class FirstClassRecipeBaseApi {
  #http = inject(HttpClient);

  deploySetupElk$({
    clientId,
    elkProjectId,
    forwardLogsFromProjectId,
    elasticsearchMode,
    projectCorePackage = 'LIGHT',
    includeLogstash = false,
    includeApm = false,
    serviceStackId = null
  }: {
    clientId: string;
    elkProjectId?: string;
    forwardLogsFromProjectId?: string;
    elasticsearchMode?: string;
    projectCorePackage?: string;
    includeLogstash?: boolean;
    includeApm?: boolean;
    serviceStackId?: string | null;
  }) {
    return this.#http.put<{ process: Process; }>(
      `/api/client/${clientId}/first-class-recipe/elk`,
      {
        elkProjectId,
        forwardLogsFromProjectId,
        elasticsearchMode,
        projectCorePackage,
        includeLogstash,
        includeApm,
        serviceStackId
      }
    );
  }

  deploySetupPrometheus$({
    clientId,
    prometheusProjectId,
    forwardMetricsFromProjectId,
    grafanaDatabaseMode,
    projectCorePackage = 'LIGHT'
  }: {
    clientId: string;
    prometheusProjectId?: string;
    forwardMetricsFromProjectId?: string;
    grafanaDatabaseMode?: string;
    projectCorePackage?: string;
  }) {
    return this.#http.put<FirstClassPrometheusSuccessResponse>(
      `/api/client/${clientId}/first-class-recipe/prometheus`,
      {
        prometheusProjectId,
        forwardMetricsFromProjectId,
        grafanaDatabaseMode,
        projectCorePackage
      }
    );
  }
}
